import { Box } from "@chakra-ui/react";
import { motion, useScroll, useSpring } from "framer-motion";

const MotionBox = motion(Box);

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <MotionBox
      style={{ scaleX }}
      position="fixed"
      top={0}
      left={0}
      right={0}
      h="3px"
      bgGradient="linear(to-r, purple.400, purple.600)"
      transformOrigin="0%"
      zIndex="banner"
    />
  );
}
